/**
 * Checks that in the object ONLY the specified property is enabled (value === true),
 * and all other properties are NOT equal to true (can be false, undefined, null, string, etc.)
 *
 * @param obj - object with flags
 * @param expectedKey - key that should be the only one with value true
 * @returns true, if only expectedKey === true
 */

import { ChartSeriesKey, VisibleSeries } from "../types";

export function isOnlyThisEnabled(
    obj: VisibleSeries | null | undefined,
    expectedKey: ChartSeriesKey
  ): boolean {
    if (!obj || !(expectedKey in obj) || obj[expectedKey] !== true) {
      return false;
    }
  
    return Object.entries(obj).every(
      ([key, value]) => key === expectedKey || value !== true
    );
  }